import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText, FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';


export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withComponentArray(FDTitleText),
    _customProps: {
      color: 'textSecondary',
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => withComponentArray(FDBodyText),
    _customProps: {
    },
  }, overrideReadOnly);
